import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

export default function FloorMapLayout() {
  return (
    <Box sx={{ width: "100vw", height: "100vh", overflow: "hidden" }}>
      <Outlet />
    </Box>
  );
}